import React, {useContext} from 'react';
import {RouteContext} from '../../../shared/enhancers/router-enhancer';
import {compose, withApollo, Query} from 'react-apollo';
import {alternativeQuery} from '../../../data/alternatives/queries';

const withAlternatives = Component => ({...restProps}) => {
  const {signin} = useContext(RouteContext);
  return (
    <Query query={alternativeQuery}>
      {({data: {topTools}, loading}) => (
        <Component {...restProps} topTools={topTools} loading={loading} signin={signin} />
      )}
    </Query>
  );
};

export default compose(
  withApollo,
  withAlternatives
);
